<template>
    <h2 class="gradation">募集中のファンド</h2>
    <template v-for="fund in fundlist" :key="fund">
        <FundTile class="my-3" :fund-id="fund.fund_id" :fund-name="fund.fund_name"
            :explanation-short="fund.explanation_short" :thumbnail-uri="fund.image" :partner-name="fund.partner_name"
            :price="fund.price" :supporter="fund.supporter" :is-watch="watchListMap[fund.fund_id]" :amount="fund.amount"
            :total-amount="fund.total_price" />
    </template>
</template>

<style scoped>
.fund-list:not(:first-child) {
    margin-top: 8px;
}
</style>

<script>
import axios from 'axios'
import FundTile from './FundTile.vue'

export default {
    name: 'RecruitFunds',
    components: {
        FundTile
    },
    data() {
        return {
            fundlist: [],
            watchListMap: [],
            condition: ''
        }
    },
    // コンポーネントマウントリスナ
    async mounted() {
        await this.fetchContent()
    },
    methods: {
        async fetchContent() {
            try {
                const res = await axios.get('/api/fund/list', {
                    params: {
                        condition: 2
                    }
                })
                this.fundlist = res.data.funds
                this.watchListMap = res.data.watchListMap
            } catch (error) {
                console.log(error)
                this.$router.push('/progressive')
                return
            }
        }
    }
}
</script>